(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

// Open menu on hover
function openMenu() {
  let items = document.querySelector('.header__inline-menu').querySelectorAll('details');

  items.forEach((item) => {
    item.addEventListener('mouseover', () => {
      document.body.classList.add('menu-opened');
      item.setAttribute('open', true);

      const ul = item.querySelector('ul');
      if (ul) {
        ul.addEventListener('mouseleave', () => {
          item.removeAttribute('open');
        });
      }

      item.addEventListener('mouseleave', () => {
        item.removeAttribute('open');
        document.body.classList.remove('menu-opened');
      });
    });
  });
}

openMenu();


// StickyHeader class
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};
    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  // Scroll logic (mobile only) + animation when sticky activates
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 600;
    const isMobile = window.innerWidth <= 749;

    if (!isMobile) {
      this.header.classList.remove('scrolled-past-header', 'sticky-animate');
      return;
    }

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // Sticky + animation trigger
    if (scrollTop > scrollThreshold) {

      // Animation only when entering sticky mode
      if (!this.header.classList.contains('scrolled-past-header')) {
        this.header.classList.add('sticky-animate');
      }

      this.header.classList.add('scrolled-past-header');

    } else {
      // Reset when above threshold
      this.header.classList.remove('scrolled-past-header', 'sticky-animate');
    }

    // Hide/reveal logic
    if (scrollTop > this.currentScrollTop && scrollTop > scrollThreshold) {
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > scrollThreshold) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= scrollThreshold) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);


// Hide/Show logo on mobile after 400px scroll
function hideLogoMobileSticky() {
  const logo = document.querySelector('.header__heading-logo-wrapper');
  const stickyHeader = document.querySelector('.section-header');
  const mainHeader = document.querySelector('header.header.header--top-left');
  const textLogo = document.querySelector('.header__heading-logo--text.medium-hide.small-up-hide');

  if (!logo || !stickyHeader || !mainHeader || !textLogo) return;

  const isMobile = window.innerWidth <= 749;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollThreshold = 400;

  if (isMobile && scrollTop > scrollThreshold) {
    logo.style.display = 'none';
    textLogo.style.display = 'inline-block';
    mainHeader.classList.add('custom_heading_wrap');
  } else {
    logo.style.display = '';
    textLogo.style.display = 'none';
    mainHeader.classList.remove('custom_heading_wrap');
  }
}

window.addEventListener('scroll', hideLogoMobileSticky);
window.addEventListener('resize', hideLogoMobileSticky);

hideLogoMobileSticky();





  } catch(e) { console.error(e); }
})();
})();
